module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/related/zh-hans/6-7383bc69e931fc727ecf1256ab0c6fce.jpg";